import { faComments } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import clsx from "clsx"
import { usePostHog } from "posthog-js/react"

import Button from "../Button/Button"
import { SupportButtonProps } from "./SupportButton.types"

import styles from "./SupportButton.module.scss"

export default function SupportButton(props: SupportButtonProps) {
    const { source, variant = "secondaryWhite", ctaText = "Need help?", inline = false } = props

    const analytics = usePostHog()

    return (
        <div className={clsx(styles.container, { [styles.inline]: inline })}>
            <Button
                variant={variant}
                clickHandler={() => {
                    analytics?.capture("open_support_chat", { source: source })
                }}
                content={
                    <>
                        <FontAwesomeIcon icon={faComments} />
                        {ctaText}
                    </>
                }
                extraClasses={["SupportButton"]}
            />
        </div>
    )
}
